import VueRouter from "vue-router";


    export class StoredStack<T>

    {

        private readonly maxItems: number;
        private readonly itemComparer: (item1: T, item2: T) => boolean; 

        readonly storageIdent = "recentModels";

        constructor(comparer: (item1: T, item2: T) => boolean, maxItems?: number) {
            this.maxItems = maxItems ? maxItems : 5;
            this.itemComparer = comparer;
        }

    getItems(): Array<T>{


            var storedItems = localStorage.getItem(this.storageIdent);
            var items = storedItems ? JSON.parse(storedItems): new Array<T>();
            return items;
        };

        add = (item: T) => {


            var items = this.getItems();

            // If it's already there, get rid of it so it can be moved
            var itemIndex = -1;
            items.some((existingItem, foundIndex) => {

                if (this.itemComparer(existingItem, item)) {
                    itemIndex = foundIndex;
                    return true;
                } else
                    return false;
            });

            switch (itemIndex) {
            case 0:
                return;
            case -1:
                break;
            default:
                items.splice(itemIndex, 1);
                break;
            }

            // Add at zero index
            items.splice(0, 0, item);

            // Trim if needed
            if (items.length > this.maxItems)
                items = items.slice(0, this.maxItems);

            // Save the items
            var asJson = JSON.stringify(items);
            localStorage.setItem(this.storageIdent, asJson);

        };
    }

    export enum PageType {
        Viewer,
        Reports,
        History,
        ConvergenceGraph,
        Dashboard
    }

    export interface IRecentlyVisitedPage {
        name: string;
        pageType: PageType,
        modelId: string;
        visitedDate: Date;
    }

    export class RecentlyVisitedPages {
        stack: StoredStack<IRecentlyVisitedPage>;

        constructor(maxItems: number = 14)  {

            const comparer = (item1: IRecentlyVisitedPage, item2: IRecentlyVisitedPage) => {
                return item1.name === item2.name;
            };

            this.stack = new StoredStack<IRecentlyVisitedPage>(comparer, maxItems);
        }

        navigateToRecentItem(item: IRecentlyVisitedPage, router: VueRouter) {

            switch (item.pageType) {
                case PageType.Viewer:
                    router.push({ name: "model-editor", params: { modelId: item.modelId } });
                    break;

                case PageType.Reports:
                    router.push({ name: "model-reports", params: { modelId: item.modelId } });
                    break;

                case PageType.ConvergenceGraph:
                    router.push({ name: "convergence-watcher", params: { jobId: item.modelId } });
                    break;

                case PageType.History:
                    router.push({ name: "model-log", params: { modelId: item.modelId } });
                    break;

                case PageType.Dashboard:
                    router.push({ name: "model-dashboard", params: { modelId: item.modelId } });
                    break;

            }


        }



    }



// WEBPACK FOOTER //
// ./ClientApp/scripts/common/ah.mb.common.stored-stack.ts